import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { ACCESS, REFRESH } from '../consts/quickBooksTypes';
import { toast } from 'react-toastify';
import { removeLoadingKey } from '../helpers/common';

export const QBLoadingKeys = {
    report: "GET_REPORT",
    refreshToken: "REFRESH_TOKEN",
}

const initialState = {
  data: {
    [REFRESH]: null,
    [ACCESS]: null
  },
  loadingKeys: [],
  reportData: null,
  firstLoading: true,
  loading: false,
}

export const fetchQuickBooksRefreshToken = createAsyncThunk(
  'quickBooks/fetchQuickBooksRefreshToken',
  async ({
    code,
  }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.get(`/api/v1/redirect-quickbooks`, {
        params: {
          code,
        }
      });
      dispatch(getRefreshTokenData({}));
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors })
      }
    }
  }
)

export const getRefreshTokenData = createAsyncThunk(
  'quickBooks/getRefreshTokenData',
  async ({}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/refresh-token`);
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors })
      }
    }
  }
)

export const refreshMyAccessToken = createAsyncThunk(
  'quickBooks/refreshMyAccessToken',
  async ({}, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.get(`/api/v1/refresh-my-access-token`);
      dispatch(getRefreshTokenData({}));
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors })
      }
    }
  }
)

export const makeReportByQB = createAsyncThunk(
  'quickBooks/makeReportByQB',
  async ({}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/get-report`);
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors })
      }
    }
  }
)

export const quickBooksSlice = createSlice({
  name: 'quickBooks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuickBooksRefreshToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchQuickBooksRefreshToken.fulfilled, (state) => {
        state.loading = false;
        state.firstLoading = false;
      })
      .addCase(fetchQuickBooksRefreshToken.rejected, (state) => {
        state.loading = false;
        state.firstLoading = false;
      })
      .addCase(getRefreshTokenData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRefreshTokenData.fulfilled, (state, action) => {
        state.loading = false;
        state.data[REFRESH] = action.payload[REFRESH];
        state.data[ACCESS] = action.payload[ACCESS];
        state.firstLoading = false;
      })
      .addCase(getRefreshTokenData.rejected, (state, action) => {
        state.loading = false;
        state.data[REFRESH] = action.payload;
        state.data[ACCESS] = action.payload;
        state.firstLoading = false;
      })
      .addCase(refreshMyAccessToken.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, QBLoadingKeys.refreshToken];
      })
      .addCase(refreshMyAccessToken.fulfilled, (state) => {
        state.loading = false;
        state.firstLoading = false;
        state.loadingKeys = removeLoadingKey(QBLoadingKeys.refreshToken, state.loadingKeys);
        toast.success(`Access token is updated successfully.`, { position: "bottom-right" })
      })
      .addCase(refreshMyAccessToken.rejected, (state, action) => {
        state.loading = false;
        state.firstLoading = false;
        state.loadingKeys = removeLoadingKey(QBLoadingKeys.refreshToken, state.loadingKeys);
        toast.error(`Access token can't be updated. Error - ${action.payload?.error}`, { position: "bottom-right" })
      })
      .addCase(makeReportByQB.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, QBLoadingKeys.report];
      })
      .addCase(makeReportByQB.fulfilled, (state, action) => {
        state.loading = false;
        state.reportData = action?.payload?.reportData;
        state.loadingKeys = removeLoadingKey(QBLoadingKeys.report, state.loadingKeys);
        toast.success(`Report is created successfully.`, { position: "bottom-right" })
      })
      .addCase(makeReportByQB.rejected, (state, action) => {
        state.loading = false;
        state.reportData = null;
        state.loadingKeys = removeLoadingKey(QBLoadingKeys.report, state.loadingKeys);
        toast.error(`Report can't be created. Error - ${action.payload?.error}`, { position: "bottom-right" })
      })
  }
})

export const { } = quickBooksSlice.actions;

export default quickBooksSlice.reducer
